import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { GlobalEventsService } from 'src/app/core/services/global-events.service';
import { PlatformService } from 'src/app/core/services/platform.service';
import { ScrollService } from 'src/app/core/services/scroll.service';
import { WindowService } from 'src/app/core/services/window.service';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-to-top',
    templateUrl: './to-top.component.html',
    styleUrls: ['./to-top.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class ToTopComponent implements OnInit {
  private _platform = inject(PlatformService);
  private _scroll = inject(ScrollService);
  private _globalEvents = inject(GlobalEventsService);
  private _window = inject(WindowService);
  private _cd = inject(ChangeDetectorRef);


  /**
   * Is to top button visible
   */
  public toTopVisible: boolean;

  ngOnInit(): void {
    this._handleScroll();
  }

  /**
   * Window scroll handler
   * @private
   */
  private _handleScroll() {
    if (this._platform.isBrowser) {
      this._globalEvents.scroll$.pipe(debounceTime(150)).subscribe(() => {
        this.toTopVisible = this._window.nativeWindow.scrollY > 300;
        this._cd.detectChanges();
      });
    }
  }

  /**
   * To top button click handler
   */
  onToTopClick() {
    this._scroll.scrollToElement(this._scroll.documentElement, 300);
  }

}
